import { render, staticRenderFns } from "./LiveCoursePreviewModal.vue?vue&type=template&id=23a43bb6&scoped=true"
import script from "./LiveCoursePreviewModal.vue?vue&type=script&lang=js"
export * from "./LiveCoursePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./LiveCoursePreviewModal.vue?vue&type=style&index=0&id=23a43bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a43bb6",
  null
  
)

export default component.exports